import 'select2';
import $ from 'jquery';
import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

function getURLparams() {
  let url = new URL(document.URL)
  let searchParams = url.searchParams
  let paramsObject = {}
  searchParams.forEach((value, key) => paramsObject[key] = value)
  return paramsObject
}

$(document).ready(function () {
  $('.tjs-filters__select--committee').select2({dropdownAutoWidth: true}).on("change", searchArticles);
  $('.tjs-filters__select--team').select2({dropdownAutoWidth: true}).on("change", searchArticles);
});

//Custom Search and Filtration
const allArticles = document.querySelectorAll('.tjs-our-team__article');
const termLink = document.querySelectorAll('.term-link');
const searchField = document.querySelector('.tjs-filters__search');
const committeeFilter = document.querySelector('.tjs-filters__select--committee');
const teamFilter = document.querySelector('.tjs-filters__select--team');
const form = document.querySelector('.tjs-filters__form');
const nothingMessage = document.querySelector('.tjs-our-team__nothing');

function searchArticles(e) {
  if (e) e.preventDefault();
  const searchValue = searchField.value.toLowerCase();
  const committeeValue = committeeFilter.value;
  const teamValue = teamFilter.value;

  changeCurrUrl(committeeValue, teamValue);

  if (nothingMessage.classList.contains('visible')) nothingMessage.classList.remove('visible');

  for (const article of allArticles) {
    const popupLink = article.querySelector('.tjs-our-team__article-link');
    const articleTitle = article.querySelector('.tjs-our-team__article-title');
    const modalNav = article.querySelector('.tjs-our-team__article-popup-nav');
    if (modalNav?.classList.contains('navigation-off')) modalNav.classList.remove('navigation-off');
    let titleText = '';
    if (articleTitle !== null) titleText = articleTitle.textContent.toLowerCase();
    if (titleText.includes(searchValue) && (committeeValue === '0' || article.classList.contains(committeeValue)) && (teamValue === '0' || article.classList.contains(teamValue))) {
      if (article.classList.contains('hide')) article.classList.remove('hide');
      if (!popupLink.hasAttribute("data-fancybox")) popupLink.dataset.fancybox = "dialog";
    } else {
      article.classList.add('hide');
      if (popupLink.hasAttribute("data-fancybox")) delete popupLink.dataset.fancybox;
    }
  }

  const visibleArticles = document.querySelectorAll('.tjs-our-team__article:not(.hide)');
  if (visibleArticles.length === 0) nothingMessage.classList.add('visible');
  if (visibleArticles.length === 1) visibleArticles[0].querySelector('.tjs-our-team__article-popup-nav')?.classList.add('navigation-off');
}

function changeCurrUrl(commVal, teamVal) {
  let url = window.location.href.split('?')[0];
  const committeeCurrElem = committeeFilter.querySelector(`option[value="${commVal}"]`).textContent;
  const teamCurrElem = teamFilter.querySelector(`option[value="${teamVal}"]`).textContent;
  let newUrl;

  if (+commVal !== 0 && +teamVal !== 0) {
    newUrl = url + '?c=' + sanitizedURLVal(committeeCurrElem) + '&t=' + sanitizedURLVal(teamCurrElem);
  } else if (+commVal !== 0) {
    newUrl = url + '?c=' + sanitizedURLVal(committeeCurrElem);
  } else if (+teamVal !== 0) {
    newUrl = url + '?t=' + sanitizedURLVal(teamCurrElem);
  } else {
    newUrl = url;
  }

  window.history.pushState({path: newUrl}, '', newUrl);
}

const sanitizedURLVal = (text) => {
  const str = text.toLowerCase().replace(/[^\w\s]/g, "").replace(/\s+/g, "-")
  return encodeURIComponent(str);
}

form.addEventListener('submit', searchArticles);
searchField.addEventListener('keyup', searchArticles);
termLink.forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault();

    document.querySelector('.carousel__button.is-close')?.dispatchEvent(new Event('click'));
    if (e.target.classList.contains('team-link')) {
      const dataId = e.target.getAttribute('data-term');
      const option = teamFilter.querySelector(`[value="${dataId}"]`);
      if (option) {
        teamFilter.value = dataId;
        committeeFilter.value = 0;
        committeeFilter.dispatchEvent(new Event('change'));
        teamFilter.dispatchEvent(new Event('change'));
      }
    } else if (e.target.classList.contains('committee-link')) {
      const dataId = e.target.getAttribute('data-term');
      const option = committeeFilter.querySelector(`[value="${dataId}"]`);
      if (option) {
        committeeFilter.value = dataId;
        teamFilter.value = 0;
        teamFilter.dispatchEvent(new Event('change'));
        committeeFilter.dispatchEvent(new Event('change'));
      }
    }
  }, false);
})


Fancybox.bind('[data-fancybox]', {
  caption: function (fancybox, carousel, slide) {
    return (
      `${slide.index + 1} / ${carousel.slides.length} <br />` + slide.caption
    );
  },
  keyboard: {
    ArrowUp: false,
    ArrowDown: false,
  },
});

Fancybox.defaults.Hash = false;

// Simulate clicking on next/prev buttons (Fancybox buttons were hide)
function buttonClick(allButtons) {
  for (const button of allButtons) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      if (this.classList.contains('tjs-our-team__article-popup-btn--next')) {
        const fancyNext = document.querySelector('.is-next');
        fancyNext.click();
      } else {
        const fancyNext = document.querySelector('.is-prev');
        fancyNext.click();
      }
    });
  }
}

const allPrevButtons = document.querySelectorAll('.tjs-our-team__article-popup-btn--prev');
const allNextButtons = document.querySelectorAll('.tjs-our-team__article-popup-btn--next');
buttonClick(allNextButtons);
buttonClick(allPrevButtons);

//get current element from url params
function urlParamOptionLoop(param, allElem) {
  const allCommittee = allElem.querySelectorAll('option[value]');
  for (const el of allCommittee) {
    if (sanitizedURLVal(el.textContent) === param) {
      el.selected = 'selected';
      break;
    }
  }
}

window.addEventListener('load', () => {
  //Filter articles by GET parameter
  let currentOption;

  if (getURLparams().c && getURLparams().t) {
    currentOption = true;
    urlParamOptionLoop(getURLparams().c, committeeFilter);
    urlParamOptionLoop(getURLparams().t, teamFilter);
  } else if (getURLparams().c) {
    currentOption = true;
    urlParamOptionLoop(getURLparams().c, committeeFilter);
  } else if (getURLparams().t) {
    currentOption = true;
    urlParamOptionLoop(getURLparams().t, teamFilter);
  }

  if (currentOption) {
    searchArticles();
    $('.tjs-filters__select--committee').select2({dropdownAutoWidth: true}).on("change", searchArticles);
    $('.tjs-filters__select--team').select2({dropdownAutoWidth: true}).on("change", searchArticles);
  }
});
